module.exports = __webpack_public_path__ + "static/media/use27.10d835b2.png";